import { useEffect, useState } from 'react';
import { Box, Typography, Skeleton, Stack, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';

export function LoadingEmpresaScreen() {
  const [startTime] = useState(Date.now());
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    console.log('[LoadingEmpresaScreen] Componente montado');
    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{ width: '100%', maxWidth: 400 }}
      >
        <CardSurface sx={{ p: 4, textAlign: 'center' }}>
          <Stack spacing={3} alignItems="center">
            <CircularProgress size={48} sx={{ color: 'primary.main' }} />
            
            <Box sx={{ width: '100%' }}>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Carregando empresa...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Tempo: {elapsed}s
              </Typography>
            </Box>

            <Stack spacing={1} sx={{ width: '100%', mt: 2 }}>
              <Skeleton variant="rectangular" height={60} sx={{ borderRadius: '12px' }} />
              <Skeleton variant="rectangular" height={40} sx={{ borderRadius: '12px' }} />
              <Skeleton variant="rectangular" height={40} sx={{ borderRadius: '12px' }} />
            </Stack>

            {elapsed > 10 && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <CardSurface
                  sx={{
                    p: 2,
                    bgcolor: 'warning.light',
                    border: '1px solid',
                    borderColor: 'warning.main',
                    mt: 2,
                  }}
                >
                  <Typography variant="body2" color="warning.dark" sx={{ fontSize: '0.875rem' }}>
                    ⚠️ Carregamento está demorando. Verifique o console (F12) para mais informações.
                  </Typography>
                </CardSurface>
              </motion.div>
            )}
          </Stack>
        </CardSurface>
      </motion.div>
    </Box>
  );
}
